import React from 'react';

import Slider from 'rc-slider';

interface RangeSliderSimpleProps {
  value: number;
  min: number;
  max: number;
  step?: number;
  onChange?: (value: number) => void;
  onAfterChange?: (value: number) => void;
}

const RangeSliderSimple = ({
  value,
  min,
  max,
  step,
  onChange,
  onAfterChange,
}: RangeSliderSimpleProps) => {
  return (
    <div data-wx-rangeslider="simple">
      <div className="range-slider">
        <Slider
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={onChange ? (v) => onChange(v as number) : undefined}
          onAfterChange={onAfterChange ? (v) => onAfterChange(v as number) : undefined}
        />
      </div>
    </div>
  );
};

export default RangeSliderSimple;
